import * as React from 'react';
import { Box, Button, Grid, IconButton} from '@mui/material'
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

export default function CustomerEditButton() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
        <IconButton sx={{ color: '#0066b2', '&:hover': {backgroundColor: '#88a3c9', color: 'white' }}} size='small'>
          <AddCircleOutlinedIcon sx={{color: 'green'}} onClick={handleClickOpen} />
        </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>UPDATE</DialogTitle>
        <DialogContent>
        <Grid item xs={12}>
              <Box sx={boxStyle.root} >
                <Grid container spacing={1}>
                  <Grid item xs={4} >
                    <TextField fullWidth size='small' label= 'id' variant="outlined"required name='id' />
                    </Grid>
                    <Grid item xs={4} >
                    <TextField fullWidth size='small' label="RegNo" variant="outlined" required name='RegNo'/>
                    </Grid>
                  <Grid item xs={4}>
                    <TextField fullWidth size='small' label="Make" variant="outlined" required name='Make'/>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField fullWidth size='small' label="Model" variant="outlined" required name='Model'/>
                  </Grid>
                  <Grid item xs={4} >
                    <TextField fullWidth size='small' label="MOT Due" variant="outlined" required name='MOT Due'/>
                  </Grid>
                  <Grid item xs={4} >
                    <TextField fullWidth size='small' label="Last Vist" variant="outlined" required name='Last Vist'/>
                  </Grid>
                </Grid>
              </Box>
              </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Save</Button>
        </DialogActions>
      </Dialog>
      <IconButton sx={{ color: '#CD5C5C', '&:hover': {backgroundColor: '#df9797', color: 'white' } }}  >
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </div>
  );
}

